module.exports = __webpack_public_path__ + "img/ti.ea1be59b.svg";